import styled from 'styled-components';

export default styled.div`
  position: relative;
  width: 100%;
  height: 10px;
  cursor: pointer;
  margin-bottom: 5px;
`;
